/**
 * @generated SignedSource<<5a35fee1cfaa8a326bc1500f46687768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type date_issueFieldDateReadviewFull_DateReadView$data = {
  readonly date: AGG$Date | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "date_issueFieldDateReadviewFull_DateReadView";
};
export type date_issueFieldDateReadviewFull_DateReadView$key = {
  readonly " $data"?: date_issueFieldDateReadviewFull_DateReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"date_issueFieldDateReadviewFull_DateReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "date_issueFieldDateReadviewFull_DateReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "date"
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "9249ac9d622710a08c9de2f57a3e7b89";

export default node;
